import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL;

let _socket = null;

export function getSocket() {
  if (!_socket) {
    _socket = io(SOCKET_URL, {
      // polling-only: Socket.IO's long-polling still pushes near-instantly, and it
      // rides over plain HTTP so it works through proxies (e.g. Apache) that aren't
      // configured to forward WebSocket upgrades for /socket.io/.
      transports: ['polling'],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
    });
  }
  return _socket;
}

export function useSocket(eventHandlers = {}) {
  const socket = getSocket();
  const handlersRef = useRef(eventHandlers);
  handlersRef.current = eventHandlers;

  useEffect(() => {
    const events = Object.keys(handlersRef.current);

    // Use named wrapper functions so we can remove ONLY this component's listener,
    // not every listener for the event (which socket.off(event) would do).
    const wrappers = {};
    events.forEach(event => {
      wrappers[event] = (...args) => handlersRef.current[event]?.(...args);
      socket.on(event, wrappers[event]);
    });

    return () => {
      events.forEach(event => socket.off(event, wrappers[event]));
    };
  }, []); // eslint-disable-line

  return socket;
}
